import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Placeholder from './placeholder';
import Card from './card';

export default class CardPlaceholder extends React.PureComponent {
  static propTypes = {
    useAvatar: PropTypes.bool,
    lines: PropTypes.number,
    allowBig: PropTypes.bool,
    color: PropTypes.oneOf(['dark', 'light']),
    className: PropTypes.string,
    avatarSize: PropTypes.oneOf(['sm', 'md', 'lg', 'xlg']),
    isOrganization: PropTypes.bool,
    border: PropTypes.oneOf(['dashed', 'none', 'thin']),
  }

  static defaultProps = {
    lines: 12,
    allowBig: true,
    color: 'light',
    avatarSize: 'md',
    isOrganization: false,
  }

  get classNames() {
    const { className, border, } = this.props;
    return classNames('ph-wrapper', {
      [border]: border,
      [className]: className,
    });
  }

  render() {
    const { useAvatar, lines, allowBig, avatarSize, isOrganization } = this.props;
    const avatarProp = useAvatar && !isOrganization ? "//s3.amazonaws.com/splicegroup-publicassets/blankuseravatar.png" : null;

    return (
      <Card
        stacked
        className={this.classNames}
        avatar={avatarProp}
        avatarSize={avatarSize}
        {...this.props}
      >
        <Placeholder
          lines={lines}
          allowBig={allowBig}
          className={classNames('width-100pct', {
            'margin-left-20': useAvatar,
          })}
        />
      </Card>
    )
  }
}
